import { render } from "./SeguimientoDocumentos.vue?vue&type=template&id=4d3744b2&scoped=true"
import script from "./SeguimientoDocumentos.vue?vue&type=script&lang=js"
export * from "./SeguimientoDocumentos.vue?vue&type=script&lang=js"

import "./SeguimientoDocumentos.vue?vue&type=style&index=0&id=4d3744b2&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4d3744b2"]])

export default __exports__